import { useWLLayoutType } from '@talos/kyoko';
import { useLayoutComponent } from './useLayoutComponent';
import { useShouldRenderMobile } from './useShouldRenderMobile';

export function useCurrentLayoutComponent() {
  const { layoutType } = useWLLayoutType();
  const isMobile = useShouldRenderMobile();
  return useLayoutComponent(layoutType, isMobile);
}
